import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ServiciosService } from 'app/services/servicios.service';
import { EquiposComponent } from 'app/components/servicio-medico/despacho/subdespacho/equipos/equipos.component';

@Component({
  selector: 'app-celular-movil',
  templateUrl: './celular-movil.component.html',
  styleUrls: ['./celular-movil.component.scss']
})
export class CelularMovilComponent implements OnInit {

  public celular;

  constructor(public dialogRef: MatDialogRef<EquiposComponent>,@Inject(MAT_DIALOG_DATA) private datos,private servicios:ServiciosService) { }

  ngOnInit() {
    this.celular = this.datos.cel
  }

  enviar(){
    this.servicios.celmovil(this.celular, this.datos.veh).subscribe((data)=>{
      console.log(data);
    })
    this.dialogRef.close(this.celular);
  }

}
